import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMinus = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("g", {
		id: "remove_24px",
		children: /* @__PURE__ */ _jsx("path", {
			id: "icon/content/remove_24px",
			d: "M19 13H5V11H19V13Z",
			fill: "#6B3FDC"
		})
	})]
});
const ForwardRef = forwardRef(SvgMinus);
export default ForwardRef;
